import * as React from "react";
import Header from "./Header";
import PqrsdTestBench from "../lab/PqrsdTestBench";

export default function LayoutPqrsdLab() {
  return (
    <>
      <Header />
      <PqrsdTestBench />
    </>
  );
}
